import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Button } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  const items = [
    {
      key: 'it',
      label: (
        <div onClick={() => changeLanguage('it')} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span>🇮🇹</span>
          <span>{t('language.italian')}</span>
        </div>
      ),
    },
    {
      key: 'en',
      label: (
        <div onClick={() => changeLanguage('en')} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span>🇬🇧</span>
          <span>{t('language.english')}</span>
        </div>
      ),
    },
    {
      key: 'es',
      label: (
        <div onClick={() => changeLanguage('es')} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span>🇪🇸</span>
          <span>{t('language.spanish')}</span>
        </div>
      ),
    },
  ];

  const getCurrentFlag = () => {
    switch (i18n.language) {
      case 'en':
        return '🇬🇧';
      case 'es':
        return '🇪🇸';
      case 'it':
      default:
        return '🇮🇹';
    }
  };

  return (
    <Dropdown menu={{ items }} placement="bottomRight" trigger={['click']}>
      <Button
        icon={<GlobalOutlined />}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          borderRadius: '8px',
          border: '1px solid rgba(0,0,0,0.1)',
        }}
      >
        <span style={{ fontSize: '16px' }}>{getCurrentFlag()}</span>
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitcher;
